import type { VisualEffect } from '../tilemap/types';

export class RingPulseEffect implements VisualEffect {
  private elapsed = 0;
  private readonly duration = 0.45;
  private readonly x: number;
  private readonly y: number;
  private readonly tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
  private readonly tileSize: number;
  private readonly color: string;

  constructor(options: {
    x: number;
    y: number;
    tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
    tileSize: number;
    color: string;
  }) {
    this.x = options.x;
    this.y = options.y;
    this.tileToScreenCenter = options.tileToScreenCenter;
    this.tileSize = options.tileSize;
    this.color = options.color;
  }

  update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
  }

  renderOverlay(ctx: CanvasRenderingContext2D): void {
    const progress = Math.min(this.elapsed / this.duration, 1);
    const center = this.tileToScreenCenter(this.x, this.y);
    const radius = this.tileSize * (0.5 + progress * 1.1);
    ctx.save();
    ctx.globalAlpha = 1 - progress;
    ctx.beginPath();
    ctx.lineWidth = this.tileSize * 0.12;
    ctx.strokeStyle = this.color;
    ctx.arc(center.x, center.y, radius, 0, Math.PI * 2);
    ctx.stroke();
    ctx.restore();
  }

  isComplete(): boolean {
    return this.elapsed >= this.duration;
  }
}
